import React from 'react';
import { X } from 'lucide-react'; // This component needs the 'X' icon
import CustomerStatusBadge from '../common/CustomerStatusBadge'; // It also needs our custom badge!

const ViewNoteModal = ({ isOpen, onClose, note }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center p-4 z-[60]">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-lg">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-bold">Contact Note Details</h2>
                    <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200"><X size={20}/></button>
                </div>
                <div className="space-y-4">
                    <div><strong>Date:</strong> {note.contactDate?.toLocaleString() || 'N/A'}</div>
                    <div><strong>Contact Type:</strong> {note.contactType}</div>
                    <div><strong>Status at time of note:</strong> <CustomerStatusBadge status={note.status} /></div>
                    <div className="mt-2 p-3 bg-gray-50 rounded-md border">
                        <p className="text-gray-800 whitespace-pre-wrap">{note.noteText}</p>
                    </div>
                </div>
                 <div className="flex justify-end mt-6">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700">Close</button>
                </div>
            </div>
        </div>
    );
};

export default ViewNoteModal;